import InputPhone, { InputPhoneProps as _InputPhoneProps } from './InputPhone';

export { InputPhone };
export type InputPhoneProps = _InputPhoneProps;
